<template>
  <v-card
    class="pa-5 author-v-card"
  >
    <v-container>
      <v-layout wrap row class="mb-4">
        <v-flex xs8>
          <h2 class="mb-4">SJOBERG ANG KHO, M.D.</h2>
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-flex xs12 md4>
          <img
            :src="author"
            width="300"
            class="image-author"
          />
        </v-flex>
        <v-flex xs12 md8>
          <div>
            <p class="subheading"> 
              <i class="purple--text">Associate Professor, University of Santo Tomas &mdash; Faculty of Medicine and Surgery</i>
            </p>
            <p class="subheading"> 
              Dr. Sjoberg Kho obtained his fellowship training in Diabetes, Endocrinology and Metabolism at University Hospital at The State University of New York (SUNY) in Stony Brook, New York and became the Chief Resident of the Department of  Internal Medicine  in the same institution.
            </p>
            <p class="subheading">
              He is a Past President of the Philippine Society of Endocrinology and Metabolism (PSEDM) and former Residency Training Officer of the UST Faculty of Medicine and Surgery and Assistant Chairman of UST Department of Medicine.
            </p>
            <p class="subheading">
              He is currently a Board of the Philippine Thyroid Association (PTA), Head of the UST Hospital Diabetes Center and Chief of UST Hospital Section of Endocrinology &amp; Metabolism.
            </p>
            <p class="subheading">
              He is an Associate Professor of the UST Faculty of Medicine &amp; Surgery and the Chief, Section of Endocrinology &amp; Metabolism, of  The same institution.
            </p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-spacer></v-spacer>
        <v-flex xs4 text-md-right>
          <v-btn
            large
            class="accent"
            to="/dashboard"
          >
            Back
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      author: require('@/assets/sjoberg_kho.jpg')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/author/kho.vue